import type { TimelineMetric } from '@/lib/utils/hospitalStatsCalc';

export const METRIC_META: Record<TimelineMetric, { label: string; color: string }> = {
  appointments: { label: 'Appointments', color: '#6B8AF9' },
  consultations: { label: 'Consultations', color: '#061A61' },
  pa: { label: 'PA', color: '#0E9F6E' },
  vitals: { label: 'Vitals', color: '#E8590C' },
};
